export const RUN_LANGSMITH_URL =
	"https://smith.langchain.com/o/c291403e-948a-41cf-9ae6-41ee515d168d/projects/p/fc6607bc-cbd6-40ac-a633-692d62c37ce0/r/";
